<template>
  <!-- Section navigation for the networking pages (AI Matches / Meetings /
       Open Sessions). Placed in each page header so the user can move
       between the networking pages from anywhere. -->
  <nav class="net-quicknav" aria-label="Networking sections">
    <router-link :to="{ name: 'ai-matches' }" class="net-quicklink">
      <i class="fas fa-sparkles" aria-hidden="true"></i>
      <span>AI Matches</span>
    </router-link>
    <router-link :to="{ name: 'my-meetings' }" class="net-quicklink">
      <i class="fal fa-calendar-alt" aria-hidden="true"></i>
      <span>Meetings</span>
    </router-link>
    <router-link :to="{ name: 'open-sessions' }" class="net-quicklink">
      <i class="fal fa-presentation" aria-hidden="true"></i>
      <span>Open Sessions</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'NetworkingQuickNav'
};
</script>

<style scoped>
/* Tab bar: single row (scrolls on small screens), a grey baseline, and the
   active tab's underline sitting on that line. */
.net-quicknav {
  display: flex;
  align-items: stretch;
  gap: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.net-quicknav::-webkit-scrollbar {
  display: none;
}
.net-quicklink {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280; /* gray-500 */
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px; /* overlap the 1px baseline */
  transition: color 0.15s ease, border-color 0.15s ease;
}
.net-quicklink i {
  font-size: 1rem;
}
.net-quicklink:hover {
  color: #111827; /* gray-900 */
}
/* Router is configured with linkActiveClass: 'active' */
.net-quicklink.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}
</style>
